export const reportError = (error) => {
  if (window.Rollbar) {
    window.Rollbar.error(error);
  } else {
    console.error('Rollbar (inactive) Error:', error);
  }
};
